import types from 'actions/types'
import {combineReducers} from 'redux'

export const isVisible = (state = false, action) => {
  switch (action.type) {
    case types.QUOTING_SHOW_BULK_CLOSE_QUOTES_DIALOG:
      return true
    case types.QUOTING_HIDE_BULK_CLOSE_QUOTES_DIALOG:
    case types.QUOTING_BULK_CLOSE_OR_REJECT_ORDERS_ATTEMPT:
      return false
    default:
      return state
  }
}

export const isBusy = (state = false, action) => {
  switch (action.type) {
    case types.QUOTING_BULK_CLOSE_OR_REJECT_ORDERS_ATTEMPT:
    case types.QUOTING_GET_ORDER_COUNT_FOR_BULK_CLOSE_ATTEMPT:
      return true
    case types.QUOTING_GET_ORDER_COUNT_FOR_BULK_CLOSE_SUCCESS:
    case types.QUOTING_GET_ORDER_COUNT_FOR_BULK_CLOSE_FAILURE:
    case types.QUOTING_BULK_CLOSE_OR_REJECT_ORDERS_SUCCESS:
    case types.QUOTING_BULK_CLOSE_OR_REJECT_ORDERS_FAILURE:
      return false
    default:
      return state
  }
}

const count = (state = 0, action) => {
  switch (action.type) {
    case types.QUOTING_GET_ORDER_COUNT_FOR_BULK_CLOSE_SUCCESS: {
      return action.count
    }
    default:
      return state
  }
}

const orderIds = (state = [], action) => {
  switch (action.type) {
    case types.QUOTING_GET_ORDER_COUNT_FOR_BULK_CLOSE_SUCCESS: {
      return action.orders.map(order => order.id)
    }
    default:
      return state
  }
}

export default combineReducers({
  isVisible,
  isBusy,
  count,
  orderIds,
})
